import { render } from "./TaskAddEditModal.vue?vue&type=template&id=2a91dc48&scoped=true"
import script from "./TaskAddEditModal.js?vue&type=script&lang=js"
export * from "./TaskAddEditModal.js?vue&type=script&lang=js"

import "./TaskAddEditModal.vue?vue&type=style&index=0&id=2a91dc48&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a91dc48"]])

export default __exports__